import { Link } from "react-router-dom";
import { Hotel, Plane, Car, Sun, Wifi, Shield, Ticket, Trophy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocale } from "@/contexts/LocaleContext";

export const QuickServicesStrip = () => {
  const { t } = useTranslation();
  const { isRTL } = useLocale();

  const services = [
    { icon: Hotel, labelKey: "quick_services.hotels", href: "/hotels" },
    { icon: Plane, labelKey: "quick_services.flights", href: "/flights" },
    { icon: Car, labelKey: "quick_services.cars", href: "/cars" },
    { icon: Sun, labelKey: "quick_services.packages", href: "/packages" },
    { icon: Wifi, labelKey: "quick_services.esim", href: "/esim" },
    { icon: Shield, labelKey: "quick_services.insurance", href: "/insurance" },
    { icon: Ticket, labelKey: "quick_services.attractions", href: "/attractions" },
    { icon: Trophy, labelKey: "quick_services.tickets", href: "/tickets" },
  ];

  return (
    <section className="py-12 md:py-16" dir={isRTL ? "rtl" : "ltr"} aria-labelledby="services-heading">
      <div className="container">
        <h2 id="services-heading" className="text-2xl md:text-3xl font-bold text-center mb-8">
          {t("quick_services.title")} <span className="text-gradient-primary">{t("quick_services.title_highlight")}</span>
        </h2>
        
        <nav aria-label={t("nav.services")} className="grid grid-cols-4 md:grid-cols-8 gap-4 md:gap-6">
          {services.map((service) => (
            <Link
              key={service.href}
              to={service.href}
              className="flex flex-col items-center gap-2 group min-h-[44px] min-w-[44px]"
              aria-label={t(service.labelKey)}
            >
              <div 
                className="h-14 w-14 md:h-16 md:w-16 rounded-2xl bg-primary/10 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:bg-primary group-hover:shadow-lg group-hover:shadow-primary/25"
                aria-hidden="true"
              >
                <service.icon className="h-6 w-6 md:h-7 md:w-7 text-primary transition-colors group-hover:text-white" aria-hidden="true" />
              </div>
              <span className="text-xs md:text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors text-center">
                {t(service.labelKey)}
              </span>
            </Link>
          ))}
        </nav>
      </div>
    </section>
  );
};